import { AnimatePresence } from 'framer-motion'
import React from 'react'

import { useManagementSearchUnitFirmwares } from '@apps-common/apis/management/unit-firmware'
import { UnitFirmwareCardSkeleton, UnitFirmwareListCard } from '@apps-common/apps/portal/pages/management/components/unit-firmware'
import { NoResultsCard, PullRefresh } from '@apps-common/components/common'
import { LayoutContainer, LayoutPadding } from '@apps-common/components/layout'

interface IProps {
  searchVal: string
}

export const UnitFirmwareInfiniteView: React.FC<IProps> = ({ searchVal }) => {
  const { isLoading, isError, data, isRefetching, refetch } = useManagementSearchUnitFirmwares({
    search: searchVal
  })

  const loading = isLoading || isRefetching || isError || !data

  return (
    <LayoutContainer>
      <LayoutPadding topPadding='pt-[60px]'>
        <PullRefresh loading={isRefetching} callback={() => refetch()} />
        <AnimatePresence>
          <div className='flex flex-col gap-4'>
            {loading && Array.from(Array(20).keys()).map((n, i) => <UnitFirmwareCardSkeleton key={`unit-firmware-card-skeleton-${i}`} />)}
            {!loading &&
              data?.map((f) => (
                <UnitFirmwareListCard key={`unit-firmware-list-${f.unitFirmwareId}`} firmware={f} onChangeCallback={refetch} />
              ))}
            {!loading && data && data.length === 0 && <NoResultsCard>No firmware results.</NoResultsCard>}
          </div>
        </AnimatePresence>
      </LayoutPadding>
    </LayoutContainer>
  )
}
